import React, { useMemo } from 'react';
import { useFetchGet } from '../../utils/fetch/useFetchGet';
import { IDeliveryList } from '../../utils/types';
import { paths, pathsApi } from '../../router/paths';
import Body from '../../ui/Body/body';
import i18n from '../../utils/i18n';
import GridRow from '../../ui/GridRow';
import GridCol from '../../ui/GridCol';
import ButtonLink from '../../ui/Button/buttonLink';
import { ButtonVariationEnum } from '../../ui/Button/types';
import Table from '../../ui/Table';
import Tag from '../../ui/Tag';
import { TagEnum } from '../../ui/Tag/types';
import { boolToReadable } from '../../utils/boolUtil';
import { getPrice } from '../../utils/getPrice';
import SortDelivery from './module/SortDelivery';

const DeliveryAll = () => {
    const { data, setData } = useFetchGet<Array<IDeliveryList>>({ path: pathsApi.deliveryAll });

    const sortedCategories = useMemo(() => {
        return data?.sort((a, b) => a.order - b.order);
    }, [data]);

    return (
        <Body title={i18n.menu.delivery} isLoading={!data}>
            <GridRow gutter={8}>
                <GridCol col={12}>
                    <GridRow isFlex gutter={8}>
                        <ButtonLink href={paths.deliveryNew} variation={ButtonVariationEnum.SOFT}>
                            {i18n.menu.deliveryNew}
                        </ButtonLink>
                        <SortDelivery deliveries={sortedCategories} setDeliveryCallback={setData} />
                    </GridRow>
                </GridCol>
                <GridCol col={12}>
                    <Table
                        widths={[40, 10]}
                        headers={[i18n.general.name, i18n.price.mainPrice, i18n.general.active]}
                        data={sortedCategories?.map((item) => ({
                            items: [
                                item.name,
                                getPrice(item.price),
                                <Tag type={!!item.deletedAt ? TagEnum.RED : TagEnum.GREEN}>
                                    {boolToReadable(!item.deletedAt)}
                                </Tag>,
                            ],
                            id: item.id,
                            link: paths.delivery + item.id,
                        }))}
                    />
                </GridCol>
            </GridRow>
        </Body>
    );
};

export default DeliveryAll;
